import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-error-display',
  template: `
    <mat-error *ngIf="error" class="error-message">
      <mat-icon *ngIf="icon" class="error-icon">{{icon}}</mat-icon>
      {{error}}
    </mat-error>
  `,
  styles: [`
    .error-message {
      display: flex;
      align-items: center;
      padding: 8px 12px;
      background-color: #ffebee;
      border-radius: 4px;
      margin: 8px 0;
      color: #d32f2f;
    }
    .error-icon {
      margin-right: 8px;
      font-size: 18px;
    }
  `]
})
export class ErrorDisplayComponent {
  @Input() error: string | null = null;
  @Input() icon: string = 'error_outline';
} 